/* eslint-disable no-unneeded-ternary */
import { get, getWithNull } from '../../Common/utils';
import { text } from '../constants';

const normalizeAgencies = ({ agencies = [] }) => {
  const agenciesList = agencies.map(agency => ({
    agencyID: get(agency, 'agencyID', ''),
    agencyName: get(agency, 'name', ''),
    partnerID: get(agency, 'partnerID', ''),
    partnerAgencyID: get(agency, 'partnerAgencyID', ''),
    active: get(agency, 'active', ''),
  }));

  return {
    list: agenciesList,
  };
};

const normalizePartners = ({ partners = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    partners.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'partnerID', ''),
    })),
  );

const normalizeAgencyCreation = (payload = {}) => {
  const normalizedPayload = {
    active: true,
    partnerID: get(payload, 'partnerID', ''),
    partnerAgencyID: get(payload, 'partnerAgencyID', ''),
    name: get(payload, 'name', ''),
  };

  return normalizedPayload;
};

const normalizeCredentialsPayload = (payload = {}) => {
  const normalizedPayload = {
    businessEntityID: getWithNull(payload, 'businessEntityID', null),
    businessMedicaidID: getWithNull(payload, 'businessMedicaidID', null),
    businessNPI: getWithNull(payload, 'businessNPI', null),
    businessTaxonomy: getWithNull(payload, 'businessTaxonomy', null),
    businessEIN: getWithNull(payload, 'businessEIN', null),
    payerUsername: getWithNull(payload, 'payerUsername', null),
    payerPassword: getWithNull(payload, 'payerPassword', null),
    claimLayoutName: getWithNull(payload, 'claimLayoutName', null),
    email: getWithNull(payload, 'email', null),
    businessName: getWithNull(payload, 'businessName', null),
    vendorID: getWithNull(payload, 'vendorID', null),
    includeBilling: get(payload, 'includeBilling', false),
    splitVisit: get(payload, 'splitVisit', false),
    overwriteEnabled: true,
  };

  return normalizedPayload;
};

const normalizeError = ({ message = {} }) => {
  const errors = get(message, 'message', [text.generalError]);

  return {
    errors,
  };
};

const normalizeSaveCredentialError = ({ message = {} }) => {
  const errors = get(message, 'messages', [text.generalError]);

  return {
    errors,
  };
};

const normalizeCredentials = ({ credentials = [] }) => {
  const credentialsList = credentials.map(credential => ({
    agencyID: get(credential, 'agencyID', ''),
    aggregatorID: get(credential, 'aggregatorID', ''),
    status: get(credential, 'status', ''),
    businessEntityID: get(credential, 'businessEntityID', ''),
    businessMedicaidID: get(credential, 'businessMedicaidID', ''),
    businessNPI: get(credential, 'businessNPI', ''),
    businessTaxonomy: get(credential, 'businessTaxonomy', ''),
    businessEIN: get(credential, 'businessEIN', ''),
    businessName: get(credential, 'businessName', ''),
    payerUsername: get(credential, 'payerUsername', ''),
    payerPassword: get(credential, 'payerPassword', ''),
    rsaPrivateKey: get(credential, 'rsaPrivateKey', ''),
    email: get(credential, 'email', ''),
    claimLayoutName: get(credential, 'claimLayoutName', ''),
    vendorID: get(credential, 'vendorID', ''),
    includeBilling: get(credential, 'includeBilling', false),
    splitVisit: get(credential, 'splitVisit', false),
  }));

  return {
    list: credentialsList,
  };
};

const normalizeNodeOptions = (aggregators = []) =>
  [{ label: 'Please Select...', value: '' }].concat(
    aggregators.map(agency => ({
      label: get(agency, 'aggregatorID', ''),
      value: get(agency, 'aggregatorID', ''),
    })),
  );

const normalizeUpdateAgencyPayload = (payload = {}) => {
  const normalizedPayload = {
    name: get(payload, 'agencyName', ''),
    active: get(payload, 'active', false),
  };

  return normalizedPayload;
};

export {
  normalizeAgencies,
  normalizePartners,
  normalizeAgencyCreation,
  normalizeError,
  normalizeCredentials,
  normalizeNodeOptions,
  normalizeCredentialsPayload,
  normalizeUpdateAgencyPayload,
  normalizeSaveCredentialError,
};
